module.exports = __webpack_public_path__ + "images/fa-cml2024-banner-side-mobile.webp";